import { Transaction } from "@/model/data/cashFlow/Transaction";
import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";

export class GetFrontBackComparisonResData extends ServiceResponseData {
    /** Lista dei dati delle transazioni per il confronto front office e back office */
    transactions: Transaction[];

    constructor(response: AxiosResponse) {
        super(response);
        this.transactions = [];
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.Transactions && obj.Transactions.length > 0) {
            obj.Transactions.forEach((e) => {
                var transaction = new Transaction();
                transaction.parse(e);
                this.transactions.push(transaction);
            });
        }
    }
}
